import { Injectable } from '@angular/core';
import { ContractService } from '../contract/contract.service';
import { Contract } from '../../interfaces/contract';
import { SessionService } from '../session/session.service';
import { SessionData } from '../../interfaces/session-data';
import { Events } from '@ionic/angular';
import { DataSourceRequestState } from '@progress/kendo-data-query';

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  constructor(
    private contractService: ContractService,
    private session: SessionService,
    private events: Events
  ) { }

  public state: DataSourceRequestState = {
    skip: 0,
    take: 5
  };
  public lastContract: Contract;
  public contracts: Contract[] = [];
  private valid = false;

  getItem(id) {
    this.session.getValue('Member').then((member) => {
      if (member !== null) {
        return member;
      } else {
        return {};
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  authorizeMember(contract: Contract, contractNumber: string, clientDocumentId: string, clientEmail: string): boolean {
    if (
      contractNumber === contract.Number &&
      (clientDocumentId === contract.MainClientDocument ||
      clientDocumentId === contract.SecondaryClientDocument
    )) {
      const member = {
        Id: contract.Id,
        Number: contract.Number,
        ContractStateName: contract.ContractStateName,
        ContractCanBeUsed: contract.ContractCanBeUsed,
        ContractCanBeUsedForHotel: contract.ContractStateName === 'Procesable' || contract.ContractStateName === 'Amortizado',
        ClientId: clientDocumentId === contract.MainClientDocument ?
          contract.MainClientId : contract.SecondaryClientId,
        ClientName: clientDocumentId === contract.MainClientDocument ?
          contract.MainClientName : contract.SecondaryClientName,
        ClientDocument: clientDocumentId === contract.MainClientDocument ?
          contract.MainClientDocument : contract.SecondaryClientDocument,
        ClientEmail: clientEmail,
        DateOfSale: contract.DateOfSale,
        DateProcessed: contract.DateProcessed
      };
      const session: SessionData = {
        email: clientEmail,
        contract: contract,
        member: member,
        primary: clientDocumentId === contract.MainClientDocument ? true : false,
        canbeused: contract.ContractCanBeUsed,
        syncdate: Date.now()
      };
      // Se guarda el Contrato
      this.session.setAll(session).then(val => {
          this.events.publish('user:login');
        }
      ).catch((err) => {
          return;
        }
      );
      return true;
    }
    return false;
  }

  async updateMember(contractNumber: string, clientDocumentId: string, clientemail: string) {
    this.contractService.findContract(
      this.state,
      contractNumber,
      clientDocumentId
    ).subscribe(contracts => {
      if (contracts) {
        this.contracts = contracts.Data;
        this.lastContract = this.contracts[0]; // Contrato
        this.valid = this.authorizeMember(
          this.lastContract,
          contractNumber,
          clientDocumentId,
          clientemail
        );
      }
    });
  }

}
